/* sp-atc.js — texto del botón de compra con envío gratis del kit Shopify maker (2026-10-19, brief offer.buyButton;
   CONTRACTS §K.3). Lo carga con defer snippets/product-form.liquid sólo con settings.sp_atc_free_text y
   settings.sp_free_from. Idempotente (flag global) y por delegación en document (sobrevive a los re-renders del editor).
   Cada span[data-sp-atc-free] (el texto del botón de agregar al carrito) dice data-sp-atc-free ("Comprar con envío gratis")
   cuando el total del carrito (data-sp-cart-total: el del servidor; después, el de cart:updated o el de /cart.js tras un
   ajaxProduct:added) más lo elegido llega a data-sp-free-from (centavos); si no, data-sp-atc-base ("Agregar al carrito").
   Lo elegido = el total de la opción marcada del bundle de ese form (data-sp-final, que sp-bundle.js recalcula con la
   variante) o el precio de la variante (data-sp-price; después, el de variantChange) × la cantidad del form. También reescribe data-default-text, que el tema usa al
   volver de "Agotado". Con el botón deshabilitado (agotado) no toca el texto. Sin listeners de scroll ni de gesto. */
(function () {
  'use strict';
  if (window.__spAtcInit) return;
  window.__spAtcInit = true;

  var SEL = '[data-sp-atc-free]';
  var prices = {}; // id de form → precio de la variante elegida (centavos)

  function toArray(list) { return Array.prototype.slice.call(list || []); }

  function selection(span) {
    var form = span.closest('form');
    // getAttribute: el form de producto tiene un campo name="id" que tapa la propiedad form.id
    var formId = form ? form.getAttribute('id') : null;
    var group = null;
    toArray(document.querySelectorAll('[data-sp-bundle]')).forEach(function (g) {
      if (!group && formId && g.getAttribute('data-form-id') === formId) group = g;
    });
    var radio = group && group.querySelector('input[name="om-bundle"]:checked');
    var tier = radio && radio.closest('[data-sp-final]');
    if (tier) return parseInt(tier.getAttribute('data-sp-final'), 10) || 0;
    var price = formId && prices[formId] != null ? prices[formId] : NaN;
    if (isNaN(price)) price = parseInt(span.getAttribute('data-sp-price'), 10);
    var qtyEl = formId ? document.querySelector('input[name="quantity"][form="' + formId + '"]') || (form && form.querySelector('input[name="quantity"]')) : null;
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    return isNaN(price) ? 0 : price * qty;
  }

  function apply(span) {
    var btn = span.closest('button');
    if (btn && btn.disabled) return;
    var from = parseInt(span.getAttribute('data-sp-free-from'), 10) || 0;
    var total = parseInt(span.getAttribute('data-sp-cart-total'), 10) || 0;
    var free = from > 0 && total + selection(span) >= from;
    var text = span.getAttribute(free ? 'data-sp-atc-free' : 'data-sp-atc-base') || '';
    if (!text) return;
    if (span.textContent.trim() !== text) span.textContent = text;
    span.setAttribute('data-default-text', text);
  }

  function all() { toArray(document.querySelectorAll(SEL)).forEach(apply); }
  function later() { setTimeout(all, 0); }

  function setTotal(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return;
    toArray(document.querySelectorAll(SEL)).forEach(function (span) { span.setAttribute('data-sp-cart-total', String(n)); });
    all();
  }

  document.addEventListener('sp:bundle:change', later);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'quantity') later();
  });
  document.addEventListener('variantChange', function (e) {
    var v = e.detail && e.detail.variant;
    var form = e.target && e.target.querySelector ? e.target.querySelector('form[action*="/cart/add"]') : null;
    var fid = form ? form.getAttribute('id') : null;
    if (v && fid) prices[fid] = parseInt(v.price, 10);
    later();
  }, true);
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart && typeof cart.total_price === 'number') setTotal(cart.total_price);
  });
  document.addEventListener('ajaxProduct:added', function () {
    if (typeof window.fetch !== 'function') return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && typeof cart.total_price === 'number') setTotal(cart.total_price); })
      .catch(function () {});
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();
